const logglyConfig = require('../loggly.json');

const env = process.env.NODE_ENV;
const apiPort = 44376;
const urlParts = window.location.hostname.split('.');
const baseSiteUrl = env !== 'development' && urlParts != null && urlParts.length > 2
  ? `${ window.location.protocol }//${ urlParts.shift() }-api.${ urlParts.join('.') }`
  : 'http://localhost';

const EnvConfig = {
  env,
  baseApiUrl: env !== 'development'
    ? `${ baseSiteUrl }`
    : `https://localhost:${ apiPort }`,
  baseSiteUrl: env !== 'development'
    ? baseSiteUrl
    : `${ baseSiteUrl }:8080`,
  tokenName: 't_0',
  optionsName: 't_a',
  firstTokenName: 't_b',
  apiEndpoints: {
    config: '/config',
    token: '/token',
    forms: '/forms',
    account: '/accounts',
    customer: '/customers',
    details: '/details',
    validation: '/validation',
    reporting: '/reporting',
    reportingXls: '/validation-result/xls',
    customerExportXls: '/customer-export/xls',
    auditTrail: '/forms/email',
    formPdf: '/forms/pdf',
    viewPdf: '/forms/pdf/view',
    bulkDelete: '/bulk-delete',
    feoption: '/feoptions',
    allocationStmnts: '/witholding-statement',
    w8imystructure: '/w8imystructure',
    WhdCalculatedResults: '/whd-calculation',
    miDashboard: '/mi-dashboard',
    miDashboardXls: '/mi-dashboard/xls',
    workflow: '/workflow',
    withholding: '/withholding',
    cicalert: '/cic-alert',
    batches: '/batches',
    legalEntities: '/legal-entities',
    activityPermissions: '/activity-permissions',
    whdStatement: '/whdstatement',
    whdManagement: '/whdstatements',
    whdManagementExcelExport: '/whdstatements/xls',
    controllingPersons: '/accounts',
    tinMatchApi: '/tinmatch',
    staticData: '/staticdata'
  },
  showAnyError: env !== 'production',
  loggly: {
    enabled: env !== 'development',
    key: logglyConfig.key,
    src: logglyConfig.src
  }
};

export default EnvConfig;
